import { render, staticRenderFns } from "./customer-contact.vue?vue&type=template&id=38c20efc"
import script from "./customer-contact.vue?vue&type=script&lang=js"
export * from "./customer-contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports